import {
  rerunOn28vy04vs1j44i as rerunOn,
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../common/LandingScreen.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  UserRole_Admin_getInstance3u101dj1ubbhu as UserRole_Admin_getInstance,
  get_entriesyts36b0as1vz as get_entries,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__toFullString_impl_igjjwy52pd76w4j0ou as MonetaryValue__toFullString_impl_igjjwy,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  Request19nuof0q5z3pj as Request,
  TableRow2fczmizw0a7dc as TableRow,
  Request2vfyg2ximc6e0 as Request_0,
  TableRow1nek1w7062qwr as TableRow_0,
  Request3glwmc9ki362z as Request_1,
  TableRowmc0fkjojxlg7 as TableRow_1,
} from '../../../../../../crowpay-shared/com/crowpay/reports/reports.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { replaceqbix900hl8kl as replace } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1i4e9ym37oxmo as serializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { downloadBlob3lmzpxtmphn66 as downloadBlob } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance_0 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import {
  Projecto73xqbcrzskm as Project,
  Contractor1wog4uk4l8u77 as Contractor,
  User8yb1tqk4kykg as User,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
  get_notNull2xk5v9at1ay9v as get_notNull,
} from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  Companion_instancek13g6rikuawd as Companion_instance_1,
  Always_getInstancecs10mhg5aot2 as Always_getInstance,
  andNotNull1zuhbghcdslbi as andNotNull,
  or1ww9501dfiqpb as or,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  get_nameo9a32lyl7xbh as get_name,
  get_contractor2weo1umt9id6t as get_contractor,
  get_customer1w9vmrtgthst as get_customer,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import {
  xDataClassPathContainsCased3idu6cb2g32wr as xDataClassPathContainsCased,
  xDataClassPathInsideSet1u5agsol0s6ul as xDataClassPathInsideSet,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { get_name166ebenv7vstz as get_name_0 } from '../../../../../../crowpay-shared/com/crowpay/ContractorFields.mjs';
import {
  get_firstName2tft79c8on6bn as get_firstName,
  get_lastName7sdqgimj4byz as get_lastName,
} from '../../../../../../crowpay-shared/com/crowpay/UserFields.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../theming/sections.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atStart2tgdnaxgj04ln as get_atStart,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  xlTitle1ubqveqr3xlnc as xlTitle,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../../theming/Titles.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { LocalDateTimeField29gd1oxpr4f6s as LocalDateTimeField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import {
  Companion_getInstance3qu5ydsg8audm as Companion_getInstance_0,
  toLocalDateTime3u4c8ydzr4ubp as toLocalDateTime,
  toInstant2q17i3aluy6ks as toInstant,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { resize3py5p2yrjp6p7 as resize } from '../../../utils/utils.mjs';
import {
  icon1sxjaie5w1apt as icon,
  errorTextv58wi1t0me7u as errorText,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { multiselectp8aawqh86psn as multiselect } from '../../components/Multiselect.mjs';
import {
  BasicListenable3uz4a8xs34a0h as BasicListenable,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import {
  beginUse146s8dwmfk72s as beginUse,
  Reactive1jy75v4li6ldv as Reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../sdk/errors.mjs';
import { get_fullName2ompl3bj5l3sh as get_fullName } from '../../../../../../crowpay-shared/com/crowpay/extensions/User.ext.shared.mjs';
import { sorted354mfsiv4s7x5 as sorted } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_HOURS_getInstancebu9fos347hpz as DurationUnit_HOURS_getInstance,
  DurationUnit_DAYS_getInstance3abv9r3rbwkq3 as DurationUnit_DAYS_getInstance,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { LocalDateTime3vqv9moe7clf4 as LocalDateTime } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import { LocalTime22kisvxz6f9p4 as LocalTime } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
import { get_DefaultSerializersModule10h5j26es502p as get_DefaultSerializersModule } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/urls.mjs';
import { StringDeferringConfig2dp4ygunddfnv as StringDeferringConfig } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/StringDeferringConfig.mjs';
import { CsvFormat2d7d3ollhiney as CsvFormat } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/CsvFormat.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_padded3m3frjnjujncx as get_padded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import { get_refresh18aehvbzyq277 as get_refresh } from '../../../icons.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../theming/separators.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance } from '../../theming/appTheme.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$rememberSuspending, $completion) {
  var tmp = rerunOn($this.cio_1.aio_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.cio_1.zin_1($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
var AdminReportingPage$Refreshable$remember$slambdaClass;
function AdminReportingPage$Refreshable$remember$slambda() {
  if (AdminReportingPage$Refreshable$remember$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.cio_1 = this$0;
      }
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AdminReportingPage$Refreshable$remember$slambdaClass = $;
  }
  return AdminReportingPage$Refreshable$remember$slambdaClass;
}
function AdminReportingPage$Refreshable$remember$slambda_0(this$0) {
  var i = new (AdminReportingPage$Refreshable$remember$slambda())(this$0);
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = tmp.pfw_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0.o88_1.d4(UserRole_Admin_getInstance()) < 0) {
    get_pageNavigator($this.dio_1).ebw(new (LandingScreen())());
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().hff_1.fff($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().hff_1.efh($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().hff_1.dfh($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().hff_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.eio_1.vev_1;
  var tmp_1 = await_1(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.eio_1.xev_1;
  var tmp_3 = await_1(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = tmp_3;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.eio_1.wev_1;
  var tmp_5 = await_1(this_3, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp_6 = tmp_5;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.eio_1.yev_1;
  var tmp_7 = await_1(this_4, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp$ret$4 = tmp_7;
  var tmp_8 = tmp_0.ffh(new (Request())(tmp_2, tmp_4, tmp_6, tmp$ret$4), $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  $this.eio_1.kew_1.mam(tmp_8);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.fio_1.kew_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var data = tmp_0;
  var tmp_1 = $this.gio_1.pc();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.fio_1.vev_1;
  var tmp_2 = await_1(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$1 = tmp_2;
  var tmp_3 = 'EscrowReport_' + replace(replace(replace(format(tmp$ret$1, Formats_getInstance().k8z_1), _Char___init__impl__6a9atx(32), _Char___init__impl__6a9atx(95)), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(95)), _Char___init__impl__6a9atx(58), _Char___init__impl__6a9atx(95)) + '.csv';
  var tmp0 = $this.fio_1.new_1;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(data, 10));
  var _iterator__ex2g4s = data.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$2 = item.p9o();
    destination.v(tmp$ret$2);
  }
  // Inline function 'kotlinx.serialization.encodeToString' call
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(KtList()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(TableRow()), arrayOf([]), false))]), false));
  var tmp$ret$6 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$7 = tmp0.x27(tmp$ret$6, destination);
  var tmp_4 = downloadBlob(tmp_1, tmp_3, toBlob(tmp$ret$7, 'application/csv'), VOID, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().hff_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.hio_1.bew_1;
  var tmp_1 = await_1(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.hio_1.cew_1;
  var tmp_3 = await_1(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = tmp_3;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.hio_1.eew_1;
  var tmp_5 = await_1(this_3, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp_6 = tmp_5;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.hio_1.dew_1;
  var tmp_7 = await_1(this_4, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp_8 = tmp_7;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_5 = $this.hio_1.few_1;
  var tmp_9 = await_1(this_5, $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  var tmp$ret$5 = tmp_9;
  var tmp_10 = tmp_0.hfh(new (Request_0())(tmp_2, tmp_4, tmp_6, tmp_8, tmp$ret$5), $completion);
  if (tmp_10 === get_COROUTINE_SUSPENDED())
    tmp_10 = yield tmp_10;
  $this.hio_1.lew_1.mam(tmp_10);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.iio_1.lew_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var data = tmp_0;
  var tmp_1 = $this.jio_1.pc();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.iio_1.bew_1;
  var tmp_2 = await_1(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$1 = tmp_2;
  var tmp_3 = formatSafe($this.iio_1, tmp$ret$1);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.iio_1.cew_1;
  var tmp_4 = await_1(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp$ret$2 = tmp_4;
  var tmp_5 = 'EscrowReport_' + tmp_3 + '_to_' + formatSafe($this.iio_1, tmp$ret$2) + '.csv';
  var tmp0 = $this.iio_1.new_1;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(data, 10));
  var _iterator__ex2g4s = data.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$3 = item.p9o();
    destination.v(tmp$ret$3);
  }
  // Inline function 'kotlinx.serialization.encodeToString' call
  // Inline function 'kotlinx.serialization.serializer' call
  var this_3 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_4 = serializer(this_3, createKType(getKClass(KtList()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(TableRow_0()), arrayOf([]), false))]), false));
  var tmp$ret$7 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
  var tmp$ret$8 = tmp0.x27(tmp$ret$7, destination);
  var tmp_6 = downloadBlob(tmp_1, tmp_5, toBlob(tmp$ret$8, 'application/csv'), VOID, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().hff_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.kio_1.gew_1;
  var tmp_1 = await_1(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp0_at = tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.kio_1.iew_1;
  var tmp_2 = await_1(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp1_projectIds = tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.kio_1.hew_1;
  var tmp_3 = await_1(this_3, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp2_homeownerIds = tmp_3;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.kio_1.jew_1;
  var tmp_4 = await_1(this_4, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp3_states = tmp_4;
  var tmp_5 = tmp_0.gfh(new (Request_1())(tmp0_at, tmp2_homeownerIds, tmp1_projectIds, tmp3_states), $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  $this.kio_1.mew_1.mam(tmp_5);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.lio_1.mew_1;
  var tmp = await_1(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var data = tmp_0;
  var tmp_1 = $this.mio_1.pc();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.lio_1.gew_1;
  var tmp_2 = await_1(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$1 = tmp_2;
  var tmp_3 = 'EscrowReport_' + replace(replace(replace(format(tmp$ret$1, Formats_getInstance().k8z_1), _Char___init__impl__6a9atx(32), _Char___init__impl__6a9atx(95)), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(95)), _Char___init__impl__6a9atx(58), _Char___init__impl__6a9atx(95)) + '.csv';
  var tmp0 = $this.lio_1.new_1;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(data, 10));
  var _iterator__ex2g4s = data.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$2 = item.p9o();
    destination.v(tmp$ret$2);
  }
  // Inline function 'kotlinx.serialization.encodeToString' call
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = tmp0.mz();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(getKClass(KtList()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(TableRow_1()), arrayOf([]), false))]), false));
  var tmp$ret$6 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var tmp$ret$7 = tmp0.x27(tmp$ret$6, destination);
  var tmp_4 = downloadBlob(tmp_1, tmp_3, toBlob(tmp$ret$7, 'application/csv'), VOID, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_10($this, $completion) {
  // Inline function 'com.lightningkite.now' call
  var tmp$ret$0 = get_default(Companion_instance_0).d1m();
  var tmp = $this.nio_1.gah(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_11($this, search, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.pfv_1;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$1);
  var tmp_2 = Companion_instance_1;
  var tmp_3 = Always_getInstance();
  // Inline function 'kotlin.takeIf' call
  var tmp_4;
  // Inline function 'kotlin.text.isNotBlank' call
  if (!isBlank(search)) {
    tmp_4 = search;
  } else {
    tmp_4 = null;
  }
  var tmp0_safe_receiver = tmp_4;
  var tmp_5;
  if (tmp0_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_5 = xDataClassPathContainsCased(get_name(it), tmp0_safe_receiver, true);
  }
  var tmp_6 = tmp_5;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.oio_1;
  var tmp_7 = await_0(this_1, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp1_safe_receiver = tmp_7;
  var tmp_8;
  if (tmp1_safe_receiver == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_9;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!tmp1_safe_receiver.i1()) {
      tmp_9 = tmp1_safe_receiver;
    } else {
      tmp_9 = null;
    }
    tmp_8 = tmp_9;
  }
  var tmp2_safe_receiver = tmp_8;
  var tmp_10;
  if (tmp2_safe_receiver == null) {
    tmp_10 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_10 = xDataClassPathInsideSet(get_contractor(it), tmp2_safe_receiver);
  }
  var tmp0_condition = andNotNull(tmp_2, [tmp_3, tmp_6, tmp_10]);
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_2 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_11 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$17 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$17);
  this_2.m4a(get_name(it_0));
  var tmp1_orderBy = this_2.o1r();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = tmp_0.feo(new (Query())(tmp0_condition, tmp1_orderBy, VOID, 100));
  var tmp_12 = await_0(this_3, $completion);
  if (tmp_12 === get_COROUTINE_SUSPENDED())
    tmp_12 = yield tmp_12;
  return tmp_12;
}
function *_generator_invoke__zhh2q8_12($this, search, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.pfv_1;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$1);
  var tmp_2 = Companion_instance_1;
  var tmp_3 = Always_getInstance();
  // Inline function 'kotlin.takeIf' call
  var tmp_4;
  // Inline function 'kotlin.text.isNotBlank' call
  if (!isBlank(search)) {
    tmp_4 = search;
  } else {
    tmp_4 = null;
  }
  var tmp0_safe_receiver = tmp_4;
  var tmp_5;
  if (tmp0_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_5 = xDataClassPathContainsCased(get_name(it), tmp0_safe_receiver, true);
  }
  var tmp_6 = tmp_5;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.pio_1.hew_1;
  var tmp_7 = await_1(this_1, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp1_safe_receiver = tmp_7;
  var tmp_8;
  if (tmp1_safe_receiver == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_9;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!tmp1_safe_receiver.i1()) {
      tmp_9 = tmp1_safe_receiver;
    } else {
      tmp_9 = null;
    }
    tmp_8 = tmp_9;
  }
  var tmp2_safe_receiver = tmp_8;
  var tmp_10;
  if (tmp2_safe_receiver == null) {
    tmp_10 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_10 = xDataClassPathInsideSet(get_notNull(get_customer(it)), tmp2_safe_receiver);
  }
  var tmp0_condition = andNotNull(tmp_2, [tmp_3, tmp_6, tmp_10]);
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_2 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_11 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$17 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$17);
  this_2.m4a(get_name(it_0));
  var tmp1_orderBy = this_2.o1r();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = tmp_0.feo(new (Query())(tmp0_condition, tmp1_orderBy, VOID, 100));
  var tmp_12 = await_0(this_3, $completion);
  if (tmp_12 === get_COROUTINE_SUSPENDED())
    tmp_12 = yield tmp_12;
  return tmp_12;
}
function *_generator_invoke__zhh2q8_13($this, search, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.jfv_1;
  var tmp_1;
  if (isBlank(search)) {
    tmp_1 = Always_getInstance();
  } else {
    // Inline function 'com.lightningkite.lightningdb.condition' call
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_2 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
    var tmp$ret$1 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$1);
    tmp_1 = xDataClassPathContainsCased(get_name_0(it), search, true);
  }
  var tmp0_condition = tmp_1;
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_3 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
  var tmp$ret$6 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$6);
  this_1.m4a(get_name_0(it_0));
  var tmp1_orderBy = this_1.o1r();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = tmp_0.feo(new (Query())(tmp0_condition, tmp1_orderBy, VOID, 100));
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return tmp_4;
}
function *_generator_invoke__zhh2q8_14($this, search, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.yfv_1;
  var tmp_1;
  if (isBlank(search)) {
    tmp_1 = Always_getInstance();
  } else {
    // Inline function 'com.lightningkite.lightningdb.condition' call
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_2 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
    var tmp$ret$1 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$1);
    tmp_1 = or(xDataClassPathContainsCased(get_firstName(it), search, true), xDataClassPathContainsCased(get_lastName(it), search, true));
  }
  var tmp0_condition = tmp_1;
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_3 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$6 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$6);
  this_1.m4a(get_firstName(it_0));
  var tmp1_orderBy = this_1.o1r();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = tmp_0.feo(new (Query())(tmp0_condition, tmp1_orderBy, VOID, 100));
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return tmp_4;
}
function formatSafe($this, _this__u8e3s4) {
  return replace(replace(replace(format(_this__u8e3s4, Formats_getInstance().k8z_1), _Char___init__impl__6a9atx(32), _Char___init__impl__6a9atx(95)), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(95)), _Char___init__impl__6a9atx(58), _Char___init__impl__6a9atx(95));
}
function snapshotCard($this, _this__u8e3s4, label, content) {
  var tmp = get_lightSection(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var tmp_0 = get_centered(view);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.jba(view_0.ob6_1.ybe(SubtitleSemantic_getInstance()));
  view_0.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_1 = view_0.tb5_1;
  var tmp_2;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(label) === 0) {
    tmp_2 = '\xA0';
  } else {
    tmp_2 = label;
  }
  tmp_1.fbu(tmp_2);
  view_0.hba(Edges().cd0(get_rem(0.5), get_px(0)));
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  var tmp_3 = get_centered(view);
  view.jbb(tmp_3, xlTitle(view, ($this$xlTitle) => {
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$xlTitle);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$xlTitle));
    var actionToCalculate = content;
    reactiveScope($this$xlTitle, ($this$reactiveScope) => {
      this_0.set(actionToCalculate($this$reactiveScope));
      return Unit_instance;
    });
    $this$xlTitle.hba(Edges().cd0(get_rem(0.5), get_px(0)));
    return Unit_instance;
  }));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function instantField($this, _this__u8e3s4, bind) {
  var tmp = get_compact(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_rem(0.1));
  var tmp_0 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.localDateTimeField' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (LocalDateTimeField())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var zone = Companion_getInstance_0().q27();
  var tmp_1 = (it) => toLocalDateTime(it, zone);
  view_0.xah(view_0.gc0_1, bind.tak(tmp_1, (it) => {
    var tmp1_elvis_lhs = it == null ? null : toInstant(it, zone);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'com.lightningkite.now' call
      tmp = get_default(Companion_instance_0).d1m();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }));
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  var tmp_2 = colored(view, AppColors_getInstance().ffz_1.xg9_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view_1.jbb(get_centered(view_1), icon(view_1, resize(Companion_getInstance().icg_1, get_rem(1.35)), 'set-now'));
  onClick(view_1, VOID, VOID, AdminReportingPage$instantField$slambda_0(bind));
  view.fbb(p_1, view_1);
  view.jbb(tmp_2, view_1);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function multiselectProjects($this, _this__u8e3s4, selected, contractors) {
  var tmp = AdminReportingPage$multiselectProjects$lambda;
  var tmp0_items = selected.tak(tmp, AdminReportingPage$multiselectProjects$lambda_0);
  var tmp1_icon = Companion_getInstance().lcg_1;
  var tmp_0 = AdminReportingPage$multiselectProjects$slambda_0(contractors);
  var tmp_1 = AdminReportingPage$multiselectProjects$lambda_1;
  var tmp_2 = AdminReportingPage$multiselectProjects$lambda_2;
  return multiselect(_this__u8e3s4, tmp_0, tmp_1, tmp_2, 'Showing all projects', AdminReportingPage$multiselectProjects$lambda_3, VOID, tmp0_items, VOID, VOID, tmp1_icon);
}
function multiselectHomeownerProjects($this, _this__u8e3s4, selected) {
  var tmp = AdminReportingPage$multiselectHomeownerProjects$lambda;
  var tmp0_items = selected.tak(tmp, AdminReportingPage$multiselectHomeownerProjects$lambda_0);
  var tmp1_icon = Companion_getInstance().lcg_1;
  var tmp_0 = AdminReportingPage$multiselectHomeownerProjects$slambda_0($this);
  var tmp_1 = AdminReportingPage$multiselectHomeownerProjects$lambda_1;
  var tmp_2 = AdminReportingPage$multiselectHomeownerProjects$lambda_2;
  return multiselect(_this__u8e3s4, tmp_0, tmp_1, tmp_2, 'Showing all projects', AdminReportingPage$multiselectHomeownerProjects$lambda_3, VOID, tmp0_items, VOID, VOID, tmp1_icon);
}
function multiselectContractors($this, _this__u8e3s4, selected) {
  var tmp = AdminReportingPage$multiselectContractors$lambda;
  var tmp0_items = selected.tak(tmp, AdminReportingPage$multiselectContractors$lambda_0);
  var tmp1_icon = Companion_getInstance().lcg_1;
  var tmp_0 = AdminReportingPage$multiselectContractors$slambda_0();
  var tmp_1 = AdminReportingPage$multiselectContractors$lambda_1;
  var tmp_2 = AdminReportingPage$multiselectContractors$lambda_2;
  return multiselect(_this__u8e3s4, tmp_0, tmp_1, tmp_2, 'Showing all contractors', AdminReportingPage$multiselectContractors$lambda_3, VOID, tmp0_items, VOID, VOID, tmp1_icon);
}
function multiselectUsers($this, _this__u8e3s4, selected) {
  var tmp = AdminReportingPage$multiselectUsers$lambda;
  var tmp0_items = selected.tak(tmp, AdminReportingPage$multiselectUsers$lambda_0);
  var tmp1_icon = Companion_getInstance().lcg_1;
  var tmp_0 = AdminReportingPage$multiselectUsers$slambda_0();
  var tmp_1 = AdminReportingPage$multiselectUsers$lambda_1;
  var tmp_2 = AdminReportingPage$multiselectUsers$lambda_2;
  return multiselect(_this__u8e3s4, tmp_0, tmp_1, tmp_2, 'Showing all Homeowners', AdminReportingPage$multiselectUsers$lambda_3, VOID, tmp0_items, VOID, VOID, tmp1_icon);
}
function multiselectStates($this, _this__u8e3s4, selected) {
  var tmp = AdminReportingPage$multiselectStates$lambda;
  var tmp0_items = selected.tak(tmp, AdminReportingPage$multiselectStates$lambda_0);
  var tmp1_icon = Companion_getInstance().lcg_1;
  var tmp_0 = AdminReportingPage$multiselectStates$slambda_0();
  var tmp_1 = AdminReportingPage$multiselectStates$lambda_1;
  var tmp_2 = AdminReportingPage$multiselectStates$lambda_2;
  return multiselect(_this__u8e3s4, tmp_0, tmp_1, tmp_2, 'Showing all states', AdminReportingPage$multiselectStates$lambda_3, VOID, tmp0_items, VOID, VOID, tmp1_icon);
}
var RefreshableClass;
function Refreshable() {
  if (RefreshableClass === VOID) {
    class $ {
      constructor(calculation) {
        this.zin_1 = calculation;
        this.aio_1 = BasicListenable().naq();
        var tmp = this;
        tmp.bio_1 = rememberSuspending(VOID, VOID, VOID, AdminReportingPage$Refreshable$remember$slambda_0(this));
      }
      qah() {
        return this.bio_1.qah();
      }
      tah(listener) {
        return this.bio_1.tah(listener);
      }
      nas() {
        this.aio_1.oaq();
      }
    }
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'Refreshable', VOID, VOID, [Reactive()]);
    RefreshableClass = $;
  }
  return RefreshableClass;
}
var AdminReportingPage$render$slambdaClass;
function AdminReportingPage$render$slambda() {
  if (AdminReportingPage$render$slambdaClass === VOID) {
    class $ {
      constructor($$this$col) {
        this.dio_1 = $$this$col;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AdminReportingPage$render$slambdaClass = $;
  }
  return AdminReportingPage$render$slambdaClass;
}
function AdminReportingPage$render$slambda_0($$this$col) {
  var i = new (AdminReportingPage$render$slambda())($$this$col);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var AdminReportingPage$render$slambdaClass_0;
function AdminReportingPage$render$slambda_1() {
  if (AdminReportingPage$render$slambdaClass_0 === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminReportingPage$render$slambdaClass_0 = $;
  }
  return AdminReportingPage$render$slambdaClass_0;
}
function AdminReportingPage$render$slambda_2() {
  var i = new (AdminReportingPage$render$slambda_1())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var AdminReportingPage$render$slambdaClass_1;
function AdminReportingPage$render$slambda_3() {
  if (AdminReportingPage$render$slambdaClass_1 === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminReportingPage$render$slambdaClass_1 = $;
  }
  return AdminReportingPage$render$slambdaClass_1;
}
function AdminReportingPage$render$slambda_4() {
  var i = new (AdminReportingPage$render$slambda_3())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var AdminReportingPage$render$slambdaClass_2;
function AdminReportingPage$render$slambda_5() {
  if (AdminReportingPage$render$slambdaClass_2 === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminReportingPage$render$slambdaClass_2 = $;
  }
  return AdminReportingPage$render$slambdaClass_2;
}
function AdminReportingPage$render$slambda_6() {
  var i = new (AdminReportingPage$render$slambda_5())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var AdminReportingPage$render$slambdaClass_3;
function AdminReportingPage$render$slambda_7() {
  if (AdminReportingPage$render$slambdaClass_3 === VOID) {
    class $ {
      constructor($total, $held, $payable) {
        this.qio_1 = $total;
        this.rio_1 = $held;
        this.sio_1 = $payable;
      }
      sao($completion) {
        this.qio_1.nas();
        this.rio_1.nas();
        this.sio_1.nas();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminReportingPage$render$slambdaClass_3 = $;
  }
  return AdminReportingPage$render$slambdaClass_3;
}
function AdminReportingPage$render$slambda_8($total, $held, $payable) {
  var i = new (AdminReportingPage$render$slambda_7())($total, $held, $payable);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var AdminReportingPage$render$slambdaClass_4;
function AdminReportingPage$render$slambda_9() {
  if (AdminReportingPage$render$slambdaClass_4 === VOID) {
    class $ {
      constructor(this$0) {
        this.eio_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminReportingPage$render$slambdaClass_4 = $;
  }
  return AdminReportingPage$render$slambdaClass_4;
}
function AdminReportingPage$render$slambda_10(this$0) {
  var i = new (AdminReportingPage$render$slambda_9())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var AdminReportingPage$render$slambdaClass_5;
function AdminReportingPage$render$slambda_11() {
  if (AdminReportingPage$render$slambdaClass_5 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.fio_1 = this$0;
        this.gio_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminReportingPage$render$slambdaClass_5 = $;
  }
  return AdminReportingPage$render$slambdaClass_5;
}
function AdminReportingPage$render$slambda_12(this$0, $$this$button) {
  var i = new (AdminReportingPage$render$slambda_11())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var AdminReportingPage$render$slambdaClass_6;
function AdminReportingPage$render$slambda_13() {
  if (AdminReportingPage$render$slambdaClass_6 === VOID) {
    class $ {
      constructor(this$0) {
        this.hio_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminReportingPage$render$slambdaClass_6 = $;
  }
  return AdminReportingPage$render$slambdaClass_6;
}
function AdminReportingPage$render$slambda_14(this$0) {
  var i = new (AdminReportingPage$render$slambda_13())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var AdminReportingPage$render$slambdaClass_7;
function AdminReportingPage$render$slambda_15() {
  if (AdminReportingPage$render$slambdaClass_7 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.iio_1 = this$0;
        this.jio_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminReportingPage$render$slambdaClass_7 = $;
  }
  return AdminReportingPage$render$slambdaClass_7;
}
function AdminReportingPage$render$slambda_16(this$0, $$this$button) {
  var i = new (AdminReportingPage$render$slambda_15())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var AdminReportingPage$render$slambdaClass_8;
function AdminReportingPage$render$slambda_17() {
  if (AdminReportingPage$render$slambdaClass_8 === VOID) {
    class $ {
      constructor(this$0) {
        this.kio_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminReportingPage$render$slambdaClass_8 = $;
  }
  return AdminReportingPage$render$slambdaClass_8;
}
function AdminReportingPage$render$slambda_18(this$0) {
  var i = new (AdminReportingPage$render$slambda_17())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var AdminReportingPage$render$slambdaClass_9;
function AdminReportingPage$render$slambda_19() {
  if (AdminReportingPage$render$slambdaClass_9 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.lio_1 = this$0;
        this.mio_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminReportingPage$render$slambdaClass_9 = $;
  }
  return AdminReportingPage$render$slambdaClass_9;
}
function AdminReportingPage$render$slambda_20(this$0, $$this$button) {
  var i = new (AdminReportingPage$render$slambda_19())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var AdminReportingPage$instantField$slambdaClass;
function AdminReportingPage$instantField$slambda() {
  if (AdminReportingPage$instantField$slambdaClass === VOID) {
    class $ {
      constructor($bind) {
        this.nio_1 = $bind;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AdminReportingPage$instantField$slambdaClass = $;
  }
  return AdminReportingPage$instantField$slambdaClass;
}
function AdminReportingPage$instantField$slambda_0($bind) {
  var i = new (AdminReportingPage$instantField$slambda())($bind);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function AdminReportingPage$multiselectProjects$lambda(it) {
  return it == null ? emptySet() : it;
}
function AdminReportingPage$multiselectProjects$lambda_0(it) {
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!it.i1()) {
    tmp = it;
  } else {
    tmp = null;
  }
  return tmp;
}
var AdminReportingPage$multiselectProjects$slambdaClass;
function AdminReportingPage$multiselectProjects$slambda() {
  if (AdminReportingPage$multiselectProjects$slambdaClass === VOID) {
    class $ {
      constructor($contractors) {
        this.oio_1 = $contractors;
      }
      ug8(search, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this, search), $completion);
      }
      s2(p1, $completion) {
        return this.ug8((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AdminReportingPage$multiselectProjects$slambdaClass = $;
  }
  return AdminReportingPage$multiselectProjects$slambdaClass;
}
function AdminReportingPage$multiselectProjects$slambda_0($contractors) {
  var i = new (AdminReportingPage$multiselectProjects$slambda())($contractors);
  var l = (search, $completion) => i.ug8(search, $completion);
  l.$arity = 1;
  return l;
}
function AdminReportingPage$multiselectProjects$lambda_1($this$multiselect, it) {
  var tmp0_elvis_lhs = $this$multiselect.baj($this$multiselect.baj(get_session()).pfv_1.kft(it));
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().nfx(getKClass(Project()), null);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function AdminReportingPage$multiselectProjects$lambda_2(it) {
  return it.x7a_1;
}
function AdminReportingPage$multiselectProjects$lambda_3(it) {
  return it.d7b_1;
}
function AdminReportingPage$multiselectHomeownerProjects$lambda(it) {
  return it == null ? emptySet() : it;
}
function AdminReportingPage$multiselectHomeownerProjects$lambda_0(it) {
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!it.i1()) {
    tmp = it;
  } else {
    tmp = null;
  }
  return tmp;
}
var AdminReportingPage$multiselectHomeownerProjects$slambdaClass;
function AdminReportingPage$multiselectHomeownerProjects$slambda() {
  if (AdminReportingPage$multiselectHomeownerProjects$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.pio_1 = this$0;
      }
      ug8(search, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, search), $completion);
      }
      s2(p1, $completion) {
        return this.ug8((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AdminReportingPage$multiselectHomeownerProjects$slambdaClass = $;
  }
  return AdminReportingPage$multiselectHomeownerProjects$slambdaClass;
}
function AdminReportingPage$multiselectHomeownerProjects$slambda_0(this$0) {
  var i = new (AdminReportingPage$multiselectHomeownerProjects$slambda())(this$0);
  var l = (search, $completion) => i.ug8(search, $completion);
  l.$arity = 1;
  return l;
}
function AdminReportingPage$multiselectHomeownerProjects$lambda_1($this$multiselect, it) {
  var tmp0_elvis_lhs = $this$multiselect.baj($this$multiselect.baj(get_session()).pfv_1.kft(it));
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().nfx(getKClass(Project()), null);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function AdminReportingPage$multiselectHomeownerProjects$lambda_2(it) {
  return it.x7a_1;
}
function AdminReportingPage$multiselectHomeownerProjects$lambda_3(it) {
  return it.d7b_1;
}
function AdminReportingPage$multiselectContractors$lambda(it) {
  return it == null ? emptySet() : it;
}
function AdminReportingPage$multiselectContractors$lambda_0(it) {
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!it.i1()) {
    tmp = it;
  } else {
    tmp = null;
  }
  return tmp;
}
var AdminReportingPage$multiselectContractors$slambdaClass;
function AdminReportingPage$multiselectContractors$slambda() {
  if (AdminReportingPage$multiselectContractors$slambdaClass === VOID) {
    class $ {
      ug8(search, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this, search), $completion);
      }
      s2(p1, $completion) {
        return this.ug8((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AdminReportingPage$multiselectContractors$slambdaClass = $;
  }
  return AdminReportingPage$multiselectContractors$slambdaClass;
}
function AdminReportingPage$multiselectContractors$slambda_0() {
  var i = new (AdminReportingPage$multiselectContractors$slambda())();
  var l = (search, $completion) => i.ug8(search, $completion);
  l.$arity = 1;
  return l;
}
function AdminReportingPage$multiselectContractors$lambda_1($this$multiselect, it) {
  var tmp0_elvis_lhs = $this$multiselect.baj($this$multiselect.baj(get_session()).jfv_1.eeo(it));
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().nfx(getKClass(Project()), null);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function AdminReportingPage$multiselectContractors$lambda_2(it) {
  return it.v5i_1;
}
function AdminReportingPage$multiselectContractors$lambda_3(it) {
  return it.x5i_1;
}
function AdminReportingPage$multiselectUsers$lambda(it) {
  return it == null ? emptySet() : it;
}
function AdminReportingPage$multiselectUsers$lambda_0(it) {
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!it.i1()) {
    tmp = it;
  } else {
    tmp = null;
  }
  return tmp;
}
var AdminReportingPage$multiselectUsers$slambdaClass;
function AdminReportingPage$multiselectUsers$slambda() {
  if (AdminReportingPage$multiselectUsers$slambdaClass === VOID) {
    class $ {
      ug8(search, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this, search), $completion);
      }
      s2(p1, $completion) {
        return this.ug8((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AdminReportingPage$multiselectUsers$slambdaClass = $;
  }
  return AdminReportingPage$multiselectUsers$slambdaClass;
}
function AdminReportingPage$multiselectUsers$slambda_0() {
  var i = new (AdminReportingPage$multiselectUsers$slambda())();
  var l = (search, $completion) => i.ug8(search, $completion);
  l.$arity = 1;
  return l;
}
function AdminReportingPage$multiselectUsers$lambda_1($this$multiselect, it) {
  var tmp0_elvis_lhs = $this$multiselect.baj($this$multiselect.baj(get_session()).yfv_1.eeo(it));
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().nfx(getKClass(Project()), null);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function AdminReportingPage$multiselectUsers$lambda_2(it) {
  return it.f88_1;
}
function AdminReportingPage$multiselectUsers$lambda_3(it) {
  return get_fullName(it);
}
function AdminReportingPage$multiselectStates$lambda(it) {
  return it == null ? emptySet() : it;
}
function AdminReportingPage$multiselectStates$lambda_0(it) {
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!it.i1()) {
    tmp = it;
  } else {
    tmp = null;
  }
  return tmp;
}
var AdminReportingPage$multiselectStates$slambdaClass;
function AdminReportingPage$multiselectStates$slambda() {
  if (AdminReportingPage$multiselectStates$slambdaClass === VOID) {
    class $ {
      ug8(search, $completion) {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = get_entries();
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (contains(element.a4_1, search, true)) {
            destination.v(element);
          }
        }
        return sorted(destination);
      }
      s2(p1, $completion) {
        return this.ug8((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AdminReportingPage$multiselectStates$slambdaClass = $;
  }
  return AdminReportingPage$multiselectStates$slambdaClass;
}
function AdminReportingPage$multiselectStates$slambda_0() {
  var i = new (AdminReportingPage$multiselectStates$slambda())();
  var l = (search, $completion) => i.ug8(search, $completion);
  l.$arity = 1;
  return l;
}
function AdminReportingPage$multiselectStates$lambda_1($this$multiselect, it) {
  return it;
}
function AdminReportingPage$multiselectStates$lambda_2(it) {
  return it;
}
function AdminReportingPage$multiselectStates$lambda_3(it) {
  return it.a4_1;
}
var AdminReportingPageClass;
function AdminReportingPage() {
  if (AdminReportingPageClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'com.lightningkite.now' call
        var tmp$ret$0 = get_default(Companion_instance_0).d1m();
        tmp.vev_1 = Signal().fak(tmp$ret$0);
        this.wev_1 = Signal().fak(null);
        this.xev_1 = Signal().fak(null);
        this.yev_1 = Signal().fak(null);
        this.zev_1 = Companion_getInstance_0().q27();
        var tmp_0 = this;
        // Inline function 'com.lightningkite.now' call
        var tmp_1 = get_default(Companion_instance_0).d1m();
        // Inline function 'kotlin.time.Companion.hours' call
        Companion_getInstance_1();
        var tmp$ret$2 = toDuration(24, DurationUnit_HOURS_getInstance());
        tmp_0.aew_1 = toInstant(LocalDateTime().u1w(toLocalDateTime(tmp_1.u26(tmp$ret$2), this.zev_1).v1w(), LocalTime().b1x(0, 0)), this.zev_1);
        var tmp_2 = this;
        // Inline function 'kotlin.time.Companion.days' call
        Companion_getInstance_1();
        var tmp$ret$3 = toDuration(7, DurationUnit_DAYS_getInstance());
        tmp_2.bew_1 = Signal().fak(this.aew_1.w26(tmp$ret$3));
        this.cew_1 = Signal().fak(this.aew_1);
        this.dew_1 = Signal().fak(null);
        this.eew_1 = Signal().fak(null);
        this.few_1 = Signal().fak(null);
        var tmp_3 = this;
        // Inline function 'com.lightningkite.now' call
        var tmp$ret$4 = get_default(Companion_instance_0).d1m();
        tmp_3.gew_1 = Signal().fak(tmp$ret$4);
        this.hew_1 = Signal().fak(null);
        this.iew_1 = Signal().fak(null);
        this.jew_1 = Signal().fak(null);
        this.kew_1 = Signal().fak(null);
        this.lew_1 = Signal().fak(null);
        this.mew_1 = Signal().fak(null);
        this.new_1 = new (CsvFormat())(new (StringDeferringConfig())(get_DefaultSerializersModule()));
      }
      ud6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        var tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        view_0.zb8(get_AppDimensions().zg1_1);
        launch(view_0, VOID, VOID, AdminReportingPage$render$slambda_0(view_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(false);
        var total = new (Refreshable())(AdminReportingPage$render$slambda_2());
        var held = new (Refreshable())(AdminReportingPage$render$slambda_4());
        var payable = new (Refreshable())(AdminReportingPage$render$slambda_6());
        snapshotCard(this, view_1, 'Total In Escrow', ($this$snapshotCard) => MonetaryValue__toFullString_impl_igjjwy($this$snapshotCard.baj(total).a5s_1));
        snapshotCard(this, view_1, 'Project Escrow', ($this$snapshotCard) => MonetaryValue__toFullString_impl_igjjwy($this$snapshotCard.baj(held).a5s_1));
        snapshotCard(this, view_1, 'Contractor Payable', ($this$snapshotCard) => MonetaryValue__toFullString_impl_igjjwy($this$snapshotCard.baj(payable).a5s_1));
        var tmp_1 = view_1.ibb(get_centered(view_1), get_textButton(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        icon(view_2, resize(get_refresh(Companion_getInstance()), get_rem_0(2)), 'refresh');
        onClick(view_2, VOID, VOID, AdminReportingPage$render$slambda_8(total, held, payable));
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp_1, view_2);
        view_0.fbb(p_1, view_1);
        // Inline function 'com.crowpay.views.screens.admin.AdminReportingPage.section' call
        var name = 'Point-In-Time Reports';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_3 = view_0.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
        view_0.ebb(p_3, view_3);
        view_3.xbm(true);
        view_3.zb8(get_rem(0.5));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.ebb(p_4, view_4);
        view_4.jba(view_4.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_2 = view_4.tb5_1;
        var tmp_3;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(name) === 0) {
          tmp_3 = '\xA0';
        } else {
          tmp_3 = name;
        }
        tmp_2.fbu(tmp_3);
        view_3.fbb(p_4, view_4);
        greySeparator(view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_3.pc());
        var tmp0_elvis_lhs_5 = view_3.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.ebb(p_5, view_5);
        view_5.xbm(true);
        // Inline function 'com.crowpay.views.components.field2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.ebb(p_6, view_6);
        view_6.xbm(true);
        view_6.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_6, 'When');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_4 = view_6.hbb(FieldSemantic_getInstance());
        var tmp$ret$14 = instantField(this, view_6, this.vev_1);
        view_6.jbb(tmp_4, tmp$ret$14);
        view_6.jbb(view_6.hbb(SubtextSemantic_getInstance()), errorText(view_6));
        view_5.fbb(p_6, view_6);
        // Inline function 'com.crowpay.views.components.field2' call
        var label = 'Contractors';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_7 = view_5.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
        view_5.ebb(p_7, view_7);
        view_7.xbm(true);
        view_7.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_7, label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_5 = view_7.hbb(FieldSemantic_getInstance());
        var tmp$ret$21 = multiselectContractors(this, view_7, this.xev_1);
        view_7.jbb(tmp_5, tmp$ret$21);
        view_7.jbb(view_7.hbb(SubtextSemantic_getInstance()), errorText(view_7));
        view_5.fbb(p_7, view_7);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_0 = 'Projects';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_8 = view_5.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_5 : tmp0_elvis_lhs_8;
        view_5.ebb(p_8, view_8);
        view_8.xbm(true);
        view_8.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_8, label_0);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_6 = view_8.hbb(FieldSemantic_getInstance());
        var tmp$ret$28 = multiselectProjects(this, view_8, this.wev_1, this.xev_1);
        view_8.jbb(tmp_6, tmp$ret$28);
        view_8.jbb(view_8.hbb(SubtextSemantic_getInstance()), errorText(view_8));
        view_5.fbb(p_8, view_8);
        // Inline function 'com.crowpay.views.components.field2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_9 = view_5.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_5 : tmp0_elvis_lhs_9;
        view_5.ebb(p_9, view_9);
        view_9.xbm(true);
        view_9.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_9, 'States');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_7 = view_9.hbb(FieldSemantic_getInstance());
        var tmp$ret$35 = multiselectStates(this, view_9, this.yev_1);
        view_9.jbb(tmp_7, tmp$ret$35);
        view_9.jbb(view_9.hbb(SubtextSemantic_getInstance()), errorText(view_9));
        view_5.fbb(p_9, view_9);
        var tmp_8 = view_5.ibb(get_atStart(view_5), get_primaryButton(view_5));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Button())(view_5.pc());
        var tmp0_elvis_lhs_10 = view_5.cbb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_5 : tmp0_elvis_lhs_10;
        view_5.ebb(p_10, view_10);
        specCenteredText(view_10, 'Generate Report');
        onClick(view_10, VOID, VOID, AdminReportingPage$render$slambda_10(this));
        view_5.fbb(p_10, view_10);
        view_5.jbb(tmp_8, view_10);
        var tmp_9 = shownWhen(view_5, VOID, ($this$shownWhen) => $this$shownWhen.baj(this.kew_1) == null);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (Frame())(view_5.pc());
        var tmp0_elvis_lhs_11 = view_5.cbb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_5 : tmp0_elvis_lhs_11;
        view_5.ebb(p_11, view_11);
        var tmp_10 = view_11.ibb(get_centered(view_11), view_11.hbb(NothingHereSemantic_getInstance()));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'Nothing To Report';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (TextView())(view_11.pc());
        var tmp0_elvis_lhs_12 = view_11.cbb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
        view_11.ebb(p_12, view_12);
        view_12.jba(view_12.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_11 = view_12.tb5_1;
        var tmp_12;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_12 = '\xA0';
        } else {
          tmp_12 = content;
        }
        tmp_11.fbu(tmp_12);
        view_11.fbb(p_12, view_12);
        view_11.jbb(tmp_10, view_12);
        view_5.fbb(p_11, view_11);
        view_5.jbb(tmp_9, view_11);
        var tmp_13 = get_centered(view_5);
        var tmp_14 = view_5.ibb(view_5.ibb(tmp_13, shownWhen(view_5, VOID, ($this$shownWhen) => !($this$shownWhen.baj(this.kew_1) == null))), get_padded(view_5));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_13 = view_5.cbb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_5 : tmp0_elvis_lhs_13;
        view_5.ebb(p_13, view_13);
        view_13.xbm(false);
        snapshotCard(this, view_13, 'Total In Escrow', ($this$snapshotCard) => {
          var tmp0_safe_receiver = $this$snapshotCard.baj(this.kew_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'com.crowpay.extensions.sumMoney' call
            var sum = Companion_instance.p91(0n);
            var _iterator__ex2g4s = tmp0_safe_receiver.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp_0 = sum;
              var tmp$ret$53 = element.j9o_1;
              sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$53);
            }
            tmp = sum;
          }
          var tmp1_safe_receiver = tmp;
          var tmp_1;
          var tmp_2 = tmp1_safe_receiver;
          if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
            tmp_1 = null;
          } else {
            tmp_1 = MonetaryValue__toFullString_impl_igjjwy(tmp1_safe_receiver);
          }
          var tmp2_elvis_lhs = tmp_1;
          return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        });
        snapshotCard(this, view_13, 'Project Escrow', ($this$snapshotCard) => {
          var tmp0_safe_receiver = $this$snapshotCard.baj(this.kew_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'com.crowpay.extensions.sumMoney' call
            var sum = Companion_instance.p91(0n);
            var _iterator__ex2g4s = tmp0_safe_receiver.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp_0 = sum;
              var tmp$ret$55 = element.k9o_1;
              sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$55);
            }
            tmp = sum;
          }
          var tmp1_safe_receiver = tmp;
          var tmp_1;
          var tmp_2 = tmp1_safe_receiver;
          if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
            tmp_1 = null;
          } else {
            tmp_1 = MonetaryValue__toFullString_impl_igjjwy(tmp1_safe_receiver);
          }
          var tmp2_elvis_lhs = tmp_1;
          return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        });
        snapshotCard(this, view_13, 'Contractor Payable', ($this$snapshotCard) => {
          var tmp0_safe_receiver = $this$snapshotCard.baj(this.kew_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'com.crowpay.extensions.sumMoney' call
            var sum = Companion_instance.p91(0n);
            var _iterator__ex2g4s = tmp0_safe_receiver.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp_0 = sum;
              var tmp$ret$57 = element.l9o_1;
              sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$57);
            }
            tmp = sum;
          }
          var tmp1_safe_receiver = tmp;
          var tmp_1;
          var tmp_2 = tmp1_safe_receiver;
          if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
            tmp_1 = null;
          } else {
            tmp_1 = MonetaryValue__toFullString_impl_igjjwy(tmp1_safe_receiver);
          }
          var tmp2_elvis_lhs = tmp_1;
          return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        });
        var tmp_15 = view_13.ibb(get_centered(view_13), get_primaryButton(view_13));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (Button())(view_13.pc());
        var tmp0_elvis_lhs_14 = view_13.cbb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
        view_13.ebb(p_14, view_14);
        icon(view_14, Companion_getInstance().hcg_1, 'export');
        onClick(view_14, VOID, VOID, AdminReportingPage$render$slambda_12(this, view_14));
        view_13.fbb(p_14, view_14);
        view_13.jbb(tmp_15, view_14);
        view_5.fbb(p_13, view_13);
        view_5.jbb(tmp_14, view_13);
        view_3.fbb(p_5, view_5);
        view_0.fbb(p_3, view_3);
        // Inline function 'com.crowpay.views.screens.admin.AdminReportingPage.section' call
        var name_0 = 'Interval Reports';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_15 = view_0.cbb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_0 : tmp0_elvis_lhs_15;
        view_0.ebb(p_15, view_15);
        view_15.xbm(true);
        view_15.zb8(get_rem(0.5));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (TextView())(view_15.pc());
        var tmp0_elvis_lhs_16 = view_15.cbb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
        view_15.ebb(p_16, view_16);
        view_16.jba(view_16.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_16 = view_16.tb5_1;
        var tmp_17;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(name_0) === 0) {
          tmp_17 = '\xA0';
        } else {
          tmp_17 = name_0;
        }
        tmp_16.fbu(tmp_17);
        view_15.fbb(p_16, view_16);
        greySeparator(view_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_17 = new (RowOrCol())(view_15.pc());
        var tmp0_elvis_lhs_17 = view_15.cbb_1;
        var p_17 = tmp0_elvis_lhs_17 == null ? view_15 : tmp0_elvis_lhs_17;
        view_15.ebb(p_17, view_17);
        view_17.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_18 = new (RowOrCol())(view_17.pc());
        var tmp0_elvis_lhs_18 = view_17.cbb_1;
        var p_18 = tmp0_elvis_lhs_18 == null ? view_17 : tmp0_elvis_lhs_18;
        view_17.ebb(p_18, view_18);
        view_18.xbm(false);
        var tmp_18 = get_expanding(view_18);
        // Inline function 'com.crowpay.views.components.field2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_19 = new (RowOrCol())(view_18.pc());
        var tmp0_elvis_lhs_19 = view_18.cbb_1;
        var p_19 = tmp0_elvis_lhs_19 == null ? view_18 : tmp0_elvis_lhs_19;
        view_18.ebb(p_19, view_19);
        view_19.xbm(true);
        view_19.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_19, 'From');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_19 = view_19.hbb(FieldSemantic_getInstance());
        var tmp$ret$82 = instantField(this, view_19, this.bew_1);
        view_19.jbb(tmp_19, tmp$ret$82);
        view_19.jbb(view_19.hbb(SubtextSemantic_getInstance()), errorText(view_19));
        view_18.fbb(p_19, view_19);
        view_18.jbb(tmp_18, view_19);
        var tmp_20 = get_expanding(view_18);
        // Inline function 'com.crowpay.views.components.field2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_20 = new (RowOrCol())(view_18.pc());
        var tmp0_elvis_lhs_20 = view_18.cbb_1;
        var p_20 = tmp0_elvis_lhs_20 == null ? view_18 : tmp0_elvis_lhs_20;
        view_18.ebb(p_20, view_20);
        view_20.xbm(true);
        view_20.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_20, 'To');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_21 = view_20.hbb(FieldSemantic_getInstance());
        var tmp$ret$89 = instantField(this, view_20, this.cew_1);
        view_20.jbb(tmp_21, tmp$ret$89);
        view_20.jbb(view_20.hbb(SubtextSemantic_getInstance()), errorText(view_20));
        view_18.fbb(p_20, view_20);
        view_18.jbb(tmp_20, view_20);
        view_17.fbb(p_18, view_18);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_1 = 'Contractors';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_21 = new (RowOrCol())(view_17.pc());
        var tmp0_elvis_lhs_21 = view_17.cbb_1;
        var p_21 = tmp0_elvis_lhs_21 == null ? view_17 : tmp0_elvis_lhs_21;
        view_17.ebb(p_21, view_21);
        view_21.xbm(true);
        view_21.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_21, label_1);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_22 = view_21.hbb(FieldSemantic_getInstance());
        var tmp$ret$100 = multiselectContractors(this, view_21, this.eew_1);
        view_21.jbb(tmp_22, tmp$ret$100);
        view_21.jbb(view_21.hbb(SubtextSemantic_getInstance()), errorText(view_21));
        view_17.fbb(p_21, view_21);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_2 = 'Projects';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_22 = new (RowOrCol())(view_17.pc());
        var tmp0_elvis_lhs_22 = view_17.cbb_1;
        var p_22 = tmp0_elvis_lhs_22 == null ? view_17 : tmp0_elvis_lhs_22;
        view_17.ebb(p_22, view_22);
        view_22.xbm(true);
        view_22.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_22, label_2);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_23 = view_22.hbb(FieldSemantic_getInstance());
        var tmp$ret$107 = multiselectProjects(this, view_22, this.dew_1, this.eew_1);
        view_22.jbb(tmp_23, tmp$ret$107);
        view_22.jbb(view_22.hbb(SubtextSemantic_getInstance()), errorText(view_22));
        view_17.fbb(p_22, view_22);
        // Inline function 'com.crowpay.views.components.field2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_23 = new (RowOrCol())(view_17.pc());
        var tmp0_elvis_lhs_23 = view_17.cbb_1;
        var p_23 = tmp0_elvis_lhs_23 == null ? view_17 : tmp0_elvis_lhs_23;
        view_17.ebb(p_23, view_23);
        view_23.xbm(true);
        view_23.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_23, 'States');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_24 = view_23.hbb(FieldSemantic_getInstance());
        var tmp$ret$114 = multiselectStates(this, view_23, this.few_1);
        view_23.jbb(tmp_24, tmp$ret$114);
        view_23.jbb(view_23.hbb(SubtextSemantic_getInstance()), errorText(view_23));
        view_17.fbb(p_23, view_23);
        var tmp_25 = view_17.ibb(get_atStart(view_17), get_primaryButton(view_17));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_24 = new (Button())(view_17.pc());
        var tmp0_elvis_lhs_24 = view_17.cbb_1;
        var p_24 = tmp0_elvis_lhs_24 == null ? view_17 : tmp0_elvis_lhs_24;
        view_17.ebb(p_24, view_24);
        specCenteredText(view_24, 'Generate Report');
        onClick(view_24, VOID, VOID, AdminReportingPage$render$slambda_14(this));
        view_17.fbb(p_24, view_24);
        view_17.jbb(tmp_25, view_24);
        var tmp_26 = shownWhen(view_17, VOID, ($this$shownWhen) => $this$shownWhen.baj(this.lew_1) == null);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_25 = new (Frame())(view_17.pc());
        var tmp0_elvis_lhs_25 = view_17.cbb_1;
        var p_25 = tmp0_elvis_lhs_25 == null ? view_17 : tmp0_elvis_lhs_25;
        view_17.ebb(p_25, view_25);
        var tmp_27 = view_25.ibb(get_centered(view_25), view_25.hbb(NothingHereSemantic_getInstance()));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content_0 = 'Nothing To Report';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_26 = new (TextView())(view_25.pc());
        var tmp0_elvis_lhs_26 = view_25.cbb_1;
        var p_26 = tmp0_elvis_lhs_26 == null ? view_25 : tmp0_elvis_lhs_26;
        view_25.ebb(p_26, view_26);
        view_26.jba(view_26.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_28 = view_26.tb5_1;
        var tmp_29;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content_0) === 0) {
          tmp_29 = '\xA0';
        } else {
          tmp_29 = content_0;
        }
        tmp_28.fbu(tmp_29);
        view_25.fbb(p_26, view_26);
        view_25.jbb(tmp_27, view_26);
        view_17.fbb(p_25, view_25);
        view_17.jbb(tmp_26, view_25);
        var tmp_30 = get_centered(view_17);
        var tmp_31 = view_17.ibb(view_17.ibb(tmp_30, shownWhen(view_17, VOID, ($this$shownWhen) => !($this$shownWhen.baj(this.lew_1) == null))), get_padded(view_17));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_27 = new (RowOrCol())(view_17.pc());
        var tmp0_elvis_lhs_27 = view_17.cbb_1;
        var p_27 = tmp0_elvis_lhs_27 == null ? view_17 : tmp0_elvis_lhs_27;
        view_17.ebb(p_27, view_27);
        view_27.xbm(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_28 = new (RowOrCol())(view_27.pc());
        var tmp0_elvis_lhs_28 = view_27.cbb_1;
        var p_28 = tmp0_elvis_lhs_28 == null ? view_27 : tmp0_elvis_lhs_28;
        view_27.ebb(p_28, view_28);
        view_28.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_29 = new (RowOrCol())(view_28.pc());
        var tmp0_elvis_lhs_29 = view_28.cbb_1;
        var p_29 = tmp0_elvis_lhs_29 == null ? view_28 : tmp0_elvis_lhs_29;
        view_28.ebb(p_29, view_29);
        view_29.xbm(false);
        var tmp_32 = get_expanding(view_29);
        view_29.jbb(tmp_32, snapshotCard(this, view_29, 'Average Daily Total Escrow', ($this$snapshotCard) => {
          var tmp0_elvis_lhs = $this$snapshotCard.baj(this.lew_1);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return '';
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var data = tmp;
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s = data.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp_0 = sum;
            var tmp$ret$132 = element.r9r_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$132);
          }
          var tmp$ret$133 = sum;
          return MonetaryValue__toFullString_impl_igjjwy(tmp$ret$133);
        }));
        var tmp_33 = get_expanding(view_29);
        view_29.jbb(tmp_33, snapshotCard(this, view_29, 'Average Daily Project Escrow', ($this$snapshotCard) => {
          var tmp0_elvis_lhs = $this$snapshotCard.baj(this.lew_1);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return '';
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var data = tmp;
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s = data.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp_0 = sum;
            var tmp$ret$134 = element.s9r_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$134);
          }
          var tmp$ret$135 = sum;
          return MonetaryValue__toFullString_impl_igjjwy(tmp$ret$135);
        }));
        var tmp_34 = get_expanding(view_29);
        view_29.jbb(tmp_34, snapshotCard(this, view_29, 'Average Daily Contractor Payable', ($this$snapshotCard) => {
          var tmp0_elvis_lhs = $this$snapshotCard.baj(this.lew_1);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return '';
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var data = tmp;
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s = data.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp_0 = sum;
            var tmp$ret$136 = element.t9r_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$136);
          }
          var tmp$ret$137 = sum;
          return MonetaryValue__toFullString_impl_igjjwy(tmp$ret$137);
        }));
        view_28.fbb(p_29, view_29);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_30 = new (RowOrCol())(view_28.pc());
        var tmp0_elvis_lhs_30 = view_28.cbb_1;
        var p_30 = tmp0_elvis_lhs_30 == null ? view_28 : tmp0_elvis_lhs_30;
        view_28.ebb(p_30, view_30);
        view_30.xbm(false);
        var tmp_35 = get_expanding(view_30);
        view_30.jbb(tmp_35, snapshotCard(this, view_30, 'Total Escrow Net Change', ($this$snapshotCard) => {
          var tmp0_elvis_lhs = $this$snapshotCard.baj(this.lew_1);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return '';
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var data = tmp;
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s = data.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp_0 = sum;
            var tmp$ret$142 = element.u9r_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$142);
          }
          var tmp$ret$143 = sum;
          return MonetaryValue__toFullString_impl_igjjwy(tmp$ret$143);
        }));
        var tmp_36 = get_expanding(view_30);
        view_30.jbb(tmp_36, snapshotCard(this, view_30, 'Project Escrow Net Change', ($this$snapshotCard) => {
          var tmp0_elvis_lhs = $this$snapshotCard.baj(this.lew_1);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return '';
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var data = tmp;
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s = data.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp_0 = sum;
            var tmp$ret$144 = element.v9r_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$144);
          }
          var tmp$ret$145 = sum;
          return MonetaryValue__toFullString_impl_igjjwy(tmp$ret$145);
        }));
        var tmp_37 = get_expanding(view_30);
        view_30.jbb(tmp_37, snapshotCard(this, view_30, 'Contractor Payable Net Change', ($this$snapshotCard) => {
          var tmp0_elvis_lhs = $this$snapshotCard.baj(this.lew_1);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return '';
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var data = tmp;
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.p91(0n);
          var _iterator__ex2g4s = data.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp_0 = sum;
            var tmp$ret$146 = element.w9r_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$146);
          }
          var tmp$ret$147 = sum;
          return MonetaryValue__toFullString_impl_igjjwy(tmp$ret$147);
        }));
        view_28.fbb(p_30, view_30);
        view_27.fbb(p_28, view_28);
        var tmp_38 = view_27.ibb(get_centered(view_27), get_primaryButton(view_27));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_31 = new (Button())(view_27.pc());
        var tmp0_elvis_lhs_31 = view_27.cbb_1;
        var p_31 = tmp0_elvis_lhs_31 == null ? view_27 : tmp0_elvis_lhs_31;
        view_27.ebb(p_31, view_31);
        icon(view_31, Companion_getInstance().hcg_1, 'export');
        onClick(view_31, VOID, VOID, AdminReportingPage$render$slambda_16(this, view_31));
        view_27.fbb(p_31, view_31);
        view_27.jbb(tmp_38, view_31);
        view_17.fbb(p_27, view_27);
        view_17.jbb(tmp_31, view_27);
        view_15.fbb(p_17, view_17);
        view_0.fbb(p_15, view_15);
        // Inline function 'com.crowpay.views.screens.admin.AdminReportingPage.section' call
        var name_1 = 'Homeowner Report';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_32 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_32 = view_0.cbb_1;
        var p_32 = tmp0_elvis_lhs_32 == null ? view_0 : tmp0_elvis_lhs_32;
        view_0.ebb(p_32, view_32);
        view_32.xbm(true);
        view_32.zb8(get_rem(0.5));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_33 = new (TextView())(view_32.pc());
        var tmp0_elvis_lhs_33 = view_32.cbb_1;
        var p_33 = tmp0_elvis_lhs_33 == null ? view_32 : tmp0_elvis_lhs_33;
        view_32.ebb(p_33, view_33);
        view_33.jba(view_33.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_39 = view_33.tb5_1;
        var tmp_40;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(name_1) === 0) {
          tmp_40 = '\xA0';
        } else {
          tmp_40 = name_1;
        }
        tmp_39.fbu(tmp_40);
        view_32.fbb(p_33, view_33);
        greySeparator(view_32);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_34 = new (RowOrCol())(view_32.pc());
        var tmp0_elvis_lhs_34 = view_32.cbb_1;
        var p_34 = tmp0_elvis_lhs_34 == null ? view_32 : tmp0_elvis_lhs_34;
        view_32.ebb(p_34, view_34);
        view_34.xbm(true);
        // Inline function 'com.crowpay.views.components.field2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_35 = new (RowOrCol())(view_34.pc());
        var tmp0_elvis_lhs_35 = view_34.cbb_1;
        var p_35 = tmp0_elvis_lhs_35 == null ? view_34 : tmp0_elvis_lhs_35;
        view_34.ebb(p_35, view_35);
        view_35.xbm(true);
        view_35.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_35, 'When');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_41 = view_35.hbb(FieldSemantic_getInstance());
        var tmp$ret$179 = instantField(this, view_35, this.gew_1);
        view_35.jbb(tmp_41, tmp$ret$179);
        view_35.jbb(view_35.hbb(SubtextSemantic_getInstance()), errorText(view_35));
        view_34.fbb(p_35, view_35);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_3 = 'Homeowners';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_36 = new (RowOrCol())(view_34.pc());
        var tmp0_elvis_lhs_36 = view_34.cbb_1;
        var p_36 = tmp0_elvis_lhs_36 == null ? view_34 : tmp0_elvis_lhs_36;
        view_34.ebb(p_36, view_36);
        view_36.xbm(true);
        view_36.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_36, label_3);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_42 = view_36.hbb(FieldSemantic_getInstance());
        var tmp$ret$186 = multiselectUsers(this, view_36, this.hew_1);
        view_36.jbb(tmp_42, tmp$ret$186);
        view_36.jbb(view_36.hbb(SubtextSemantic_getInstance()), errorText(view_36));
        view_34.fbb(p_36, view_36);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_4 = 'Projects';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_37 = new (RowOrCol())(view_34.pc());
        var tmp0_elvis_lhs_37 = view_34.cbb_1;
        var p_37 = tmp0_elvis_lhs_37 == null ? view_34 : tmp0_elvis_lhs_37;
        view_34.ebb(p_37, view_37);
        view_37.xbm(true);
        view_37.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_37, label_4);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_43 = view_37.hbb(FieldSemantic_getInstance());
        var tmp$ret$193 = multiselectHomeownerProjects(this, view_37, this.iew_1);
        view_37.jbb(tmp_43, tmp$ret$193);
        view_37.jbb(view_37.hbb(SubtextSemantic_getInstance()), errorText(view_37));
        view_34.fbb(p_37, view_37);
        // Inline function 'com.crowpay.views.components.field2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_38 = new (RowOrCol())(view_34.pc());
        var tmp0_elvis_lhs_38 = view_34.cbb_1;
        var p_38 = tmp0_elvis_lhs_38 == null ? view_34 : tmp0_elvis_lhs_38;
        view_34.ebb(p_38, view_38);
        view_38.xbm(true);
        view_38.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_38, 'States');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_44 = view_38.hbb(FieldSemantic_getInstance());
        var tmp$ret$200 = multiselectStates(this, view_38, this.jew_1);
        view_38.jbb(tmp_44, tmp$ret$200);
        view_38.jbb(view_38.hbb(SubtextSemantic_getInstance()), errorText(view_38));
        view_34.fbb(p_38, view_38);
        var tmp_45 = view_34.ibb(get_atStart(view_34), get_primaryButton(view_34));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_39 = new (Button())(view_34.pc());
        var tmp0_elvis_lhs_39 = view_34.cbb_1;
        var p_39 = tmp0_elvis_lhs_39 == null ? view_34 : tmp0_elvis_lhs_39;
        view_34.ebb(p_39, view_39);
        specCenteredText(view_39, 'Generate Report');
        onClick(view_39, VOID, VOID, AdminReportingPage$render$slambda_18(this));
        view_34.fbb(p_39, view_39);
        view_34.jbb(tmp_45, view_39);
        var tmp_46 = shownWhen(view_34, VOID, ($this$shownWhen) => $this$shownWhen.baj(this.lew_1) == null);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_40 = new (Frame())(view_34.pc());
        var tmp0_elvis_lhs_40 = view_34.cbb_1;
        var p_40 = tmp0_elvis_lhs_40 == null ? view_34 : tmp0_elvis_lhs_40;
        view_34.ebb(p_40, view_40);
        var tmp_47 = view_40.ibb(get_centered(view_40), view_40.hbb(NothingHereSemantic_getInstance()));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content_1 = 'Nothing To Report';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_41 = new (TextView())(view_40.pc());
        var tmp0_elvis_lhs_41 = view_40.cbb_1;
        var p_41 = tmp0_elvis_lhs_41 == null ? view_40 : tmp0_elvis_lhs_41;
        view_40.ebb(p_41, view_41);
        view_41.jba(view_41.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_48 = view_41.tb5_1;
        var tmp_49;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content_1) === 0) {
          tmp_49 = '\xA0';
        } else {
          tmp_49 = content_1;
        }
        tmp_48.fbu(tmp_49);
        view_40.fbb(p_41, view_41);
        view_40.jbb(tmp_47, view_41);
        view_34.fbb(p_40, view_40);
        view_34.jbb(tmp_46, view_40);
        var tmp_50 = get_centered(view_34);
        var tmp_51 = view_34.ibb(view_34.ibb(tmp_50, shownWhen(view_34, VOID, ($this$shownWhen) => !($this$shownWhen.baj(this.mew_1) == null))), get_padded(view_34));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_42 = new (RowOrCol())(view_34.pc());
        var tmp0_elvis_lhs_42 = view_34.cbb_1;
        var p_42 = tmp0_elvis_lhs_42 == null ? view_34 : tmp0_elvis_lhs_42;
        view_34.ebb(p_42, view_42);
        view_42.xbm(false);
        snapshotCard(this, view_42, 'Total In Escrow', ($this$snapshotCard) => {
          var tmp0_safe_receiver = $this$snapshotCard.baj(this.mew_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'com.crowpay.extensions.sumMoney' call
            var sum = Companion_instance.p91(0n);
            var _iterator__ex2g4s = tmp0_safe_receiver.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp_0 = sum;
              var tmp$ret$218 = element.z9p_1;
              sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$218);
            }
            tmp = sum;
          }
          var tmp1_safe_receiver = tmp;
          var tmp_1;
          var tmp_2 = tmp1_safe_receiver;
          if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
            tmp_1 = null;
          } else {
            tmp_1 = MonetaryValue__toFullString_impl_igjjwy(tmp1_safe_receiver);
          }
          var tmp2_elvis_lhs = tmp_1;
          return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        });
        snapshotCard(this, view_42, 'Project Escrow', ($this$snapshotCard) => {
          var tmp0_safe_receiver = $this$snapshotCard.baj(this.mew_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'com.crowpay.extensions.sumMoney' call
            var sum = Companion_instance.p91(0n);
            var _iterator__ex2g4s = tmp0_safe_receiver.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp_0 = sum;
              var tmp$ret$220 = element.a9q_1;
              sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$220);
            }
            tmp = sum;
          }
          var tmp1_safe_receiver = tmp;
          var tmp_1;
          var tmp_2 = tmp1_safe_receiver;
          if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
            tmp_1 = null;
          } else {
            tmp_1 = MonetaryValue__toFullString_impl_igjjwy(tmp1_safe_receiver);
          }
          var tmp2_elvis_lhs = tmp_1;
          return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        });
        snapshotCard(this, view_42, 'Contractor Payable', ($this$snapshotCard) => {
          var tmp0_safe_receiver = $this$snapshotCard.baj(this.mew_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'com.crowpay.extensions.sumMoney' call
            var sum = Companion_instance.p91(0n);
            var _iterator__ex2g4s = tmp0_safe_receiver.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp_0 = sum;
              var tmp$ret$222 = element.b9q_1;
              sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$222);
            }
            tmp = sum;
          }
          var tmp1_safe_receiver = tmp;
          var tmp_1;
          var tmp_2 = tmp1_safe_receiver;
          if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
            tmp_1 = null;
          } else {
            tmp_1 = MonetaryValue__toFullString_impl_igjjwy(tmp1_safe_receiver);
          }
          var tmp2_elvis_lhs = tmp_1;
          return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        });
        var tmp_52 = view_42.ibb(get_centered(view_42), get_primaryButton(view_42));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_43 = new (Button())(view_42.pc());
        var tmp0_elvis_lhs_43 = view_42.cbb_1;
        var p_43 = tmp0_elvis_lhs_43 == null ? view_42 : tmp0_elvis_lhs_43;
        view_42.ebb(p_43, view_43);
        icon(view_43, Companion_getInstance().hcg_1, 'export');
        onClick(view_43, VOID, VOID, AdminReportingPage$render$slambda_20(this, view_43));
        view_42.fbb(p_43, view_43);
        view_42.jbb(tmp_52, view_43);
        view_34.fbb(p_42, view_42);
        view_34.jbb(tmp_51, view_42);
        view_32.fbb(p_34, view_34);
        view_0.fbb(p_32, view_32);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_44 = new (Space())(view_0.pc(), 10.0);
        var tmp0_elvis_lhs_44 = view_0.cbb_1;
        var p_44 = tmp0_elvis_lhs_44 == null ? view_0 : tmp0_elvis_lhs_44;
        view_0.ebb(p_44, view_44);
        view_0.fbb(p_44, view_44);
        view.fbb(p_0, view_0);
        view.jbb(tmp_0, view_0);
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'AdminReportingPage', AdminReportingPage, VOID, [Page()]);
    AdminReportingPageClass = $;
  }
  return AdminReportingPageClass;
}
//region block: exports
export {
  AdminReportingPage as AdminReportingPage2yeyg5apo8s8x,
};
//endregion

//# sourceMappingURL=AdminReportingPage.mjs.map
